export const config = {
    currencies: {
        ADA: {
            symbol: "ADA",
            decimals: "6"
        }
    },
    checkout: {
        currency: "ADA",
        amountList: ["500", "250", "100", "50"]
    },
    transaction: {
        maxMonitoredDepth: 10
    },
    merchants: {
        'save-the-children': {
            returnUrl: `${process.env.REACT_APP_MERCHANTS}/save-the-children`,
            title: "Save the Children",
            image: 'save-the-children.svg',
        }
    },
    statuses: {
        confirmed: "confirmed",
        expired: "expired",
        pending: "pending",
        payment_sent: "payment_sent",
    },
    errorMessages: {
        success: "The payment was completed successfully.",
        expired: "We did not detect a payment. If you have already paid please contact the merchant to resolve your payment status.",
    },
    statusTitles: {
        confirmed: "Payment Successful",
        expired: "Payment Expired",
        payment_sent: "Payment Sent"
    },
    decimalsUSD: {
        ADA: 6,
        BTC: 2
    }
}